<mat-accordion multi="true">
  <span *ngIf="!isSelectedLocationValid">
        {{"NO_LOCATION_SELECTED_THRESHOLD"|translate}}
  </span>
  <span *ngIf="isSelectedLocationValid">
    <mat-expansion-panel id="newThresholdPanel" [expanded]="true">
    <mat-expansion-panel-header class="blueHeader">
      {{"NEW_THRESHOLD"|translate}}
    </mat-expansion-panel-header>
    <div class="panel">
      <div id="newThresHoldForm" class="panelContent">
        <div id="datePickerStartDateTresholdCont" style="display: flex; align-items: center">
          <input id="datePickerStartThresholdDate"
                 placeholder="Choose a start date"
                 matInput
                 [matDatepicker]="datePickerStartThreshold"
                 [(ngModel)]="dateStartPicker">
          <mat-datepicker-toggle matSuffix
                                 [for]="datePickerStartThreshold"></mat-datepicker-toggle>
          <mat-datepicker #datePickerStartThreshold style="display: block"></mat-datepicker>
          <ngb-timepicker [(ngModel)]="timeStartPicker" [seconds]="true"
                          [disabled]="disabled"></ngb-timepicker>
        </div>
        <div style="margin-top: 40px">
          <div id="datePickerEndDateThresholdCont" style="display: flex; align-items: center">
            <input id="datePickerEndThresholdDate"
                   placeholder="Choose an end date"
                   matInput
                   [matDatepicker]="pickerDateEndThreshold"
                   [(ngModel)]="dateEndPicker">
            <mat-datepicker-toggle matSuffix
                                   [for]="pickerDateEndThreshold"></mat-datepicker-toggle>
            <mat-datepicker #pickerDateEndThreshold style="display: block"></mat-datepicker>
            <ngb-timepicker [(ngModel)]="timeEndPicker" [seconds]="true"
                            [disabled]="disabled"></ngb-timepicker>
          </div>
        </div>
        <div style="margin-top: 20px">
          <div style="margin-top: 20px">
            <input [(ngModel)]="thresholdValue"
                   type="number"
                   step="0.1"
                   [placeholder]="'VALUE' | translate">
            <mat-select style="width: 140px;margin-left: 40px;height: 33px;padding-top: 6px; }"
                        [(ngModel)]="thresholdLevel"
                        [placeholder]="'LEVEL' | translate">
              <mat-option [value]="level" *ngFor="let level of thresholdLevels">{{level.name}}</mat-option>
            </mat-select>
            <button (click)="submitThreshold()"
                    id="submitThresholdBtn"
                    class="btn btn-success">
              {{ 'ADD_TO_THRESHOLD_TABLE' | translate }}
            </button>
          </div>
        </div>

      </div>
    </div>


    </mat-expansion-panel>


    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header class="blueHeader">
        {{"THRESHOLD_TABLE"|translate}}
      </mat-expansion-panel-header>
      <div class="panel">
        <div>
          <table>
            <thead>
            <tr class="tableLabels">
              <th style="width: 170px">{{ 'DATE_START' | translate }}</th>
              <th style="width: 170px">{{ 'DATE_END' | translate }}</th>
              <th>{{ 'VALUE' | translate }}</th>
              <th style="margin-left: 20px">{{ 'LEVEL' | translate }}</th>
              <th style="width: 260px"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let threshold of selectedLocationThresholdTable, let i = index">
              <th *ngIf="!threshold.selected">{{threshold['dateStartToDisplay']}}</th>
              <th *ngIf="threshold.selected" class="datePickerInputChange"
                  id="datePickerInputDateStartThresholdChangeCont" style="align-items: center">
                <input style="width: 70% !important;"
                       id="datePickerInputDateStartThresholdChange" matInput
                       [matDatepicker]="picker"
                       placeholder="Choose a date"
                       [(ngModel)]="dateStartPickerThreshold">
                <mat-datepicker-toggle matSuffix
                                       [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <ngb-timepicker [(ngModel)]="timeStartPickerThreshold"
                                [seconds]="true"
                                [disabled]="disabled"></ngb-timepicker>
              </th>
              <th *ngIf="!threshold.selected">{{threshold['dateEndToDisplay']}}</th>
              <th *ngIf="threshold.selected" id="datePickerInputDateEndThresholdChangeCont"
                  class="datePickerInputChange" style="align-items: center">
                <input style="width: 70% !important;"
                       id="datePickerInputDateEndThresholdChange" matInput
                       [matDatepicker]="picker"
                       placeholder="Choose a date"
                       [(ngModel)]="dateEndPickerThreshold">
                <mat-datepicker-toggle matSuffix
                                       [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <ngb-timepicker [(ngModel)]="timeEndPickerThreshold"
                                [seconds]="true"
                                [disabled]="disabled"></ngb-timepicker>
              </th>
              <th class="values">
                <span style="width: 80px;" *ngIf="!threshold.selected">{{threshold.value}}</span>
                <input style="width: 80px"
                       *ngIf="threshold.selected"
                       [(ngModel)]="threshold.value"
                       type="number"
                       step="0.1">
              </th>
              <th class="level">
                <span *ngIf="!threshold.selected">{{threshold.thresholdLevel.name}}</span>
                <div style="margin-left: 20px; width: 100px;" *ngIf="threshold.selected">
                  <mat-select [compareWith]="compareCurrentThresholdLevel"
                    [placeholder]="'LEVEL' | translate" [(value)]="threshold.thresholdLevel">
                    <mat-option [value]="level" *ngFor="let level of thresholdLevels">{{level.name}}</mat-option>
                  </mat-select>
                </div>
              </th>
              <th [ngClass]="threshold.selected ? 'submitUpdateCont' : ''">
                <div class="updateButtonsCont"
                     *ngIf="!threshold.selected">
                  <button class="btn btn-info"
                          (click)="onPatchThresholdButtonClick(threshold)"
                          [ngbTooltip]="'UPDATE' | translate">
                    <fa-icon [icon]="faPen">
                    </fa-icon>
                  </button>
                  <button class="btn btn-warning"
                          (click)="deleteThreshold(threshold.id)"
                          [ngbTooltip]="'DELETE' | translate">
                    <fa-icon [icon]="faTrash">
                    </fa-icon>
                  </button>
                </div>
                <div *ngIf="threshold.selected">
                  <button
                          (click)="threshold.selected = undefined"
                          class="bootstrapStyle btn btn-primary offsetStyleButt deleteOffsetButt">
                    {{ 'CANCEL' | translate }}
                  </button>
                  <button class="bootstrapStyle btn btn-warning"
                          (click)="onPatchClick(threshold)">
                    {{ 'VALIDATE' | translate }}
                  </button>
                </div>
              </th>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-expansion-panel>
  </span>
  <mat-expansion-panel [expanded]="!isSelectedLocationValid">
    <mat-expansion-panel-header class="blueHeader">
      {{"THRESHOLD_JSON_CONFIG"|translate}}
    </mat-expansion-panel-header>
    <div class="panelFooter">
      <div class="modal-body">
        <div class="description">{{'UPLOAD_JSON_FILE_TO_CREATE_THRESHOLD' | translate}}</div>
        <input type="file" style="display: none" #file multiple (change)="addFile()"/>

        <button style="margin: 10px 10px 10px 0 !important;"
                class="btn btn-outline-dark savebtn" (click)="file.click()">{{'CHOOSE_FILES' | translate}}</button>
        <div style="margin-left: 5px" class="files-names-cont">
          <div *ngIf="!selectedFile; else filesNamesCont">{{'NO_FILE_CHOSEN' | translate}}</div>
          <ng-template #filesNamesCont>
            <li>{{selectedFile.name}}</li>
          </ng-template>
          <button class="btn btn-info" *ngIf="selectedFile" (click)="sendThresholdJson(this.selectedFile)">{{"SEND_THRESHOLD_JSON_FILE" | translate}}</button>
          <button type="button" class="btn list-tools" placement="right" style="color:lightblue"
                  (click)="getDefaultJsonThresholdFile()"
                  [matTooltip]="'GET_DEFAULT_JSON_THRESHOLD_FILE' | translate">
            <fa-icon [icon]="faDownload"></fa-icon>
          </button>
          <button type="button" class="btn list-tools" placement="right"
                  (click)="getJsonThresholdFile()"
                  [matTooltip]="'GET_CURRENT_JSON_THRESHOLD_FILE' | translate">
            <fa-icon [icon]="faDownload"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
<div class="panelHeader"></div>
